import React from 'react';
import WorkspaceRequestConfirmation from './WorkspaceRequestConfirmation';
import { workspaceRequestSteps } from '../constants';
import WorkspaceRequestInfo from './WorkspaceRequestInfo';

const wizardContent = {
  [workspaceRequestSteps.WORKSPACE.name]: { component: WorkspaceRequestInfo },
  [workspaceRequestSteps.COMPLETE.name]: { component: WorkspaceRequestConfirmation },
};

const WorkspaceRequestWizardContent = ({
  activeStep,
  category,
  code,
  compact,
  hideSteps,
}) => {
  const content = wizardContent[activeStep];
  const Component = content.component;

  return (
    <Component
      category={category}
      code={code}
      entity={content.entity}
      compact={compact}
      hideSteps={hideSteps}
    />
  );
};

export default WorkspaceRequestWizardContent;
